import { userApi } from "@/core/data/api";

export default async () => {
  return await userApi.downloadUploadUserTemplate();
};
